import React from "react";
import PropTypes from "prop-types";
import StatusBadge from "../../v2/components/StatusBadge";

const GATE_TONE = {
    MATCH:    "success",
    MISMATCH: "error",
    UNKNOWN:  "neutral",
};

function SourcesTable({ sources }) {
    if (!sources || sources.length === 0) {
        return <p className="text-xs text-gray-400 font-sans italic mt-1">No source attempts recorded.</p>;
    }

    return (
        <table className="w-full text-xs font-sans mt-2 border-separate border-spacing-y-1">
            <thead>
                <tr className="text-gray-400 text-[10px] uppercase tracking-wide">
                    <th className="pr-4 text-left pl-2 font-semibold">Source</th>
                    <th className="pr-4 text-left font-semibold">Gate</th>
                    <th className="pr-4 text-right font-semibold">Found / passed</th>
                    <th className="pr-4 text-right font-semibold">Pack price</th>
                    <th className="pr-4 text-left pl-2 font-semibold">Pack</th>
                    <th className="pr-4 text-right font-semibold">Total</th>
                    <th className="pr-4 text-right font-semibold">Latency</th>
                    <th className="pr-4 text-left pl-2 font-semibold">Selected</th>
                </tr>
            </thead>
            <tbody>
                {sources.map((s, i) => (
                    <tr
                        key={i}
                        className={`rounded ${s.selected ? "bg-green-50" : "bg-gray-50"}`}
                    >
                        <td className="pr-4 pl-2 py-1 font-semibold text-black capitalize">{s.source}</td>
                        <td className="pr-4 py-1">
                            <StatusBadge
                                label={s.gateDecision || "—"}
                                tone={GATE_TONE[s.gateDecision] || "neutral"}
                            />
                        </td>
                        <td className="pr-4 py-1 text-right text-gray-600">
                            {s.candidates != null ? `${s.candidates} / ${s.passed}` : "—"}
                        </td>
                        <td className="pr-4 py-1 text-right text-black">
                            {s.sellingPrice != null ? `₹${s.sellingPrice}` : "—"}
                        </td>
                        <td className="pr-4 py-1 pl-2 text-gray-600">{s.packLabel || "—"}</td>
                        <td className="pr-4 py-1 text-right text-black">
                            {s.totalPrice != null ? `₹${s.totalPrice}` : "—"}
                        </td>
                        <td className="pr-4 py-1 text-right text-gray-500">
                            {s.latencyMs != null ? `${s.latencyMs}ms` : "—"}
                        </td>
                        <td className="pr-4 py-1 pl-2">
                            {s.selected ? (
                                <span className="text-green-600 font-bold">✓ Won</span>
                            ) : (
                                <span className="text-gray-300">—</span>
                            )}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}

SourcesTable.propTypes = {
    sources: PropTypes.arrayOf(PropTypes.shape({
        source:       PropTypes.string,
        gateDecision: PropTypes.string,
        sellingPrice: PropTypes.number,
        packLabel:    PropTypes.string,
        totalPrice:   PropTypes.number,
        selected:     PropTypes.bool,
        candidates:   PropTypes.number,
        passed:       PropTypes.number,
        latencyMs:    PropTypes.number,
    })),
};

SourcesTable.defaultProps = { sources: [] };

export default SourcesTable;
